import React from 'react';
import PropTypes from 'prop-types';
import { Text } from 'office-ui-fabric-react/lib/Text';
import keys from 'lodash/keys';
import isEmpty from 'lodash/isEmpty';
import uniqueId from 'lodash/uniqueId';

const detailsSectionCreator = item => {
  const counter = 'details-';
  const changeDetails = [];
  let productAllocStatus = false;

  if (!isEmpty(item?.detailedDiff?.added)) {
    const { added } = item.detailedDiff;
    const addedCount = keys(added).length;
    changeDetails.push({
      id: uniqueId(counter),
      message: `Added ${addedCount} ${addedCount > 1 ? 'products' : 'product'}`,
    });
    productAllocStatus = true;
  }

  if (!isEmpty(item?.detailedDiff?.deleted)) {
    const { deleted } = item.detailedDiff;
    const removedCount = keys(deleted).length;
    changeDetails.push({
      id: uniqueId(counter),
      message: `Removed ${removedCount} ${removedCount > 1 ? 'products' : 'product'}`,
    });
    productAllocStatus = true;
  }

  if (!isEmpty(item?.detailedDiff?.updated)) {
    const { updated } = item.detailedDiff;
    if ('0' in updated)
      changeDetails.push({
        id: uniqueId(counter),
        message: 'Updated product allocations',
      });
    if ('startDate' in updated || 'endDate' in updated)
      changeDetails.push({
        id: uniqueId(counter),
        message: 'Updated effective date range',
      });
    productAllocStatus = false;
  }

  if (productAllocStatus === true)
    changeDetails.push({
      id: uniqueId(counter),
      message: 'Updated product allocations',
    });

  return changeDetails;
};

const BundleActivityDetails = ({ item, className }) => {
  const details = detailsSectionCreator(item);

  return details.length > 0 ? (
    <ul className={className}>
      {details.map(detail => (
        <Text as="li" variant="small" key={detail.id} block>
          {detail.message}
        </Text>
      ))}
    </ul>
  ) : (
    <></>
  );
};

BundleActivityDetails.propTypes = {
  item: PropTypes.shape({
    timestamp: PropTypes.string.isRequired,
    _id: PropTypes.string.isRequired,
    initiatedBy: PropTypes.shape({
      name: PropTypes.string.isRequired,
      email: PropTypes.string.isRequired,
    }),
    operation: PropTypes.string.isRequired,
    area: PropTypes.string.isRequired,
    newData: PropTypes.shape({}),
  }),
  className: PropTypes.string,
};

BundleActivityDetails.defaultProps = {
  item: {},
  className: '',
};
export default BundleActivityDetails;
